import { PlusLg } from "react-bootstrap-icons";

//Common
import useIconStyles from "./styles";
import { IconProps } from "../../../types";

const PlusIcon = (props: IconProps) => {
  const { iconText, pendingText } = props;
  const iconStyles = useIconStyles();

  return (
    <div style={iconStyles.container}>
      <PlusLg style={iconStyles.viewIcon} />
      <div style={iconStyles.iconText}>
        {iconText} {pendingText}
      </div>
    </div>
  );
};

export default PlusIcon;
